var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row rwd-split g-3"},[_c('div',{staticClass:"rwd-split__primary",class:_vm.primaryClasses},[_vm._t("primary")],2),_c('div',{staticClass:"rwd-split__secondary",class:_vm.secondaryClasses},[_vm._t("secondary")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }